
      var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgMenu = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M4 11.998a1 1 0 1 0 2 0 1 1 0 0 0-2 0ZM11 11.998a1 1 0 1 0 2 0 1 1 0 0 0-2 0ZM18 11.998a1 1 0 1 0 2 0 1 1 0 0 0-2 0Z",
  stroke: "#fff",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));

      const __svgRaw = "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n<path d=\"M4.00049 11.998C4.00049 12.2633 4.10585 12.5176 4.29338 12.7052C4.48092 12.8927 4.73527 12.998 5.00049 12.998C5.2657 12.998 5.52006 12.8927 5.70759 12.7052C5.89513 12.5176 6.00049 12.2633 6.00049 11.998C6.00049 11.7328 5.89513 11.4785 5.70759 11.2909C5.52006 11.1034 5.2657 10.998 5.00049 10.998C4.73527 10.998 4.48092 11.1034 4.29338 11.2909C4.10585 11.4785 4.00049 11.7328 4.00049 11.998Z\" stroke=\"white\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n<path d=\"M10.9995 11.998C10.9995 12.2633 11.1049 12.5176 11.2924 12.7052C11.4799 12.8927 11.7343 12.998 11.9995 12.998C12.2647 12.998 12.5191 12.8927 12.7066 12.7052C12.8942 12.5176 12.9995 12.2633 12.9995 11.998C12.9995 11.7328 12.8942 11.4785 12.7066 11.2909C12.5191 11.1034 12.2647 10.998 11.9995 10.998C11.7343 10.998 11.4799 11.1034 11.2924 11.2909C11.1049 11.4785 10.9995 11.7328 10.9995 11.998Z\" stroke=\"white\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n<path d=\"M18 11.998C18 12.2633 18.1054 12.5176 18.2929 12.7052C18.4804 12.8927 18.7348 12.998 19 12.998C19.2652 12.998 19.5196 12.8927 19.7071 12.7052C19.8946 12.5176 20 12.2633 20 11.998C20 11.7328 19.8946 11.4785 19.7071 11.2909C19.5196 11.1034 19.2652 10.998 19 10.998C18.7348 10.998 18.4804 11.1034 18.2929 11.2909C18.1054 11.4785 18 11.7328 18 11.998Z\" stroke=\"white\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/menu.c8e8a333020be62a2474f7c822b97ed2.svg"),
        {
          React: SvgMenu,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      